<template>
  <svg
    width="16.0020786px"
    height="12.0078px"
    viewBox="0 0 16.0020786 12.0078"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Dashboard-DNA"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="arrow"
        transform="translate(-1839, -209)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <g id="Group-8" transform="translate(1411, 163)">
          <g id="ic_arrow_right_24" transform="translate(428, 46)">
            <polygon
              id="Path"
              points="10.0106607 12.0078 8.93719834 10.9593019 13.1311909 6.76530936 0 6.76530936 0 5.26745489 13.1311909 5.26745489 8.91223414 1.04849813 9.98569646 0 16.0020786 6.01638213"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
